import { thunk } from 'easy-peasy';
import { IThunkUpdatedBloodPressureReading } from '../types';

const onUpdatedBloodPressureReading: IThunkUpdatedBloodPressureReading = thunk(
  // @ts-ignore
  async ({ setUpdatedBloodPressureReading }, payload) => {
    setUpdatedBloodPressureReading(payload);
  },
);

export default onUpdatedBloodPressureReading;
